module.exports = __webpack_public_path__ + "img/icon-profile.ffca02cc.svg";